import angular from 'angular';
import constants from 'app/constants';
import {
  loaderService,
  ssDialogService,
  userService,
  vmDataService,
} from 'app/services';
import {
  alerts
} from 'app/components/global';

import controller from './update-frequency-dialog.controller';
import template from './update-frequency-dialog.html';


class dialogService {
  getOptions($event, {
    product,
    updateCallBack,
  }) {
    return {
      controller,
      controllerAs: 'updateFrequencyConfirmDialogVM',
      locals: {
        product,
        updateCallBack,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.vendorManagement.updateFrequencyConfirmDialog', [
  alerts,
  vmDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('updateFrequencyConfirmDialog', dialogService)
  .name;
